import type { DeviceType } from "utils/src/uaDevicesParse/ua-device-parser";

export type PlaidClientType = "android" | "ios" | "h5" | "web";

/**
 * Native Plaid Link (`openPlaidLinkInApp`) runs only on App shell routes.
 * `desktop` / `h5` use react-plaid-link in the browser.
 */
export const isPlaidNativeLinkRoute = (device?: DeviceType | string): boolean =>
  device === "android" || device === "ios";

/**
 * Maps App route `[device]` to member `GetFinancialConnectRequest.client_type`.
 */
export const resolvePlaidClientType = (
  device?: DeviceType | string,
): PlaidClientType => {
  if (device === "android") {
    return "android";
  }
  if (device === "ios") {
    return "ios";
  }
  if (device === "h5") {
    return "h5";
  }
  return "web";
};
